<template>
<div class="page_order page">
	<!-- 订单类型 -->
	<van-tabs v-model="order_type" swipe-threshold="6" @change="changeOrderType">
        <van-tab title="个人" :name="1"></van-tab>
        <van-tab title="团体" :name="2"></van-tab>
    </van-tabs>
	<!-- 订单状态 -->
	<van-tabs v-model="status" swipe-threshold="6" @change="changeTab">
        <van-tab title="全部" :name="-1"></van-tab>
        <van-tab title="待支付" :name="0"></van-tab>
        <van-tab title="支付中" :name="1"></van-tab>
        <van-tab title="支付成功" :name="2"></van-tab>
    </van-tabs>
	<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
		<div class="list">
			<div class="item" v-for="(order,index) in orderList" :key="index">
				<div class="item_t">
					<div class="item_t_t">
						<!-- <img :src="order.tradesman_thumb ? order.tradesman_thumb : $publicData.defaultTouxiang" alt="" class="thumb"> -->
						<div class="title">{{ order.order_type == 2 ? '团体票' : '个人票' }} <span v-if="order.ticket.is_through_ticket">(通票)</span></div>
					</div>
					<div class="status">{{ order.statusTitle }}</div>
				</div>
				<!--  @click="goOrderDetail(order)" -->
				<div class="item_nr unflex">
					<div class="item_nr_l">
						<!-- <img :src="goods.thumb ? goods.thumb: $publicData.intangibleDefault" alt="" class="tu"> -->
						<img :src="order.thumb ? imageUrl+order.thumb :$publicData.intangibleDefault" alt="" class="tu">
					</div>
					<div class="item_nr_r">
						<div class="item_nr_r_t">
							<div class="title slh">
								<span class="" v-if="order.ticket.venue">展馆:{{ order.ticket.venue.title }}</span>
								<span class="" v-else>园区通票</span>
							</div>
							<!-- <div class="title slh">订单编号:{{ order.order_sn }}</div> -->
							<div class="title slh">下单时间:{{ order.created_at }}</div>
							<div class="title slh">参观时间:{{ order.ticket.date_at +' '+ order.ticket.beigin_at+'-'+order.ticket.end_at }}</div>
							<div class="title slh" v-if="order.order_type != 2">订单金额:￥{{ order.total_price }}</div>
							<!-- <div class="info">
								<span class="price"><span class="tag_cash">¥</span>{{ goods.price }}</span>
								<span class="nums">x{{ goods.num }}</span>
							</div> -->
						</div>
					</div>
				</div>
				<div class="item_b">
					<div class="actions">
						<div class="action" @click="toDetail(order)">查看详情</div>
						<!-- 团体票线下支付 -->
						<div class="action" v-if="order.pay_status != 2 && order.order_type != 2" @click="toPay(order)">付款</div>
					</div>
				</div>
			</div>
		</div>
	</van-list>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			status: -1,
			loading: true,
			finished: false,
			orderList: [],
			pages: {
				page: 1,
				size: 10
			},
			goNext: false,
			order_type: 1 // 订单类型 1个人 2团体
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
		if(this.$route.query.order_type){
			this.order_type = parseInt(this.$route.query.order_type)
		}
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '智慧园区订单',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						this.getData()
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
					
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			this.getData()
        }
    },
	mounted() {
	},
	destroyed(){
		// console.log('触发了销毁')
		localStorage.removeItem('userTicket')
	},
	activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.pages.page = 1
			this.getData()
		}
	},
    methods: {
		// 获取订单数据
		getData(){
			if (!this.token) {
				return
			}
			var that = this
			var params = {
				token: that.token,
				order_type: that.order_type,
				page: that.pages.page,
				size: that.pages.size,
				status: that.status
			}
			that.$api.smartpark.orderlist(params).then(res=>{
				if(res.code == 200){
					var list = res.result
					if(list.length != 0){
						if (this.pages.page = 1) {
							that.orderList = []
						}
						for(var i in list){
							if(list[i].pay_status == 2){
								list[i].statusTitle = '支付完成'
							}else if(list[i].pay_status == 1){
								list[i].statusTitle = '支付中'
							}else if(list[i].pay_status == 0){
								if(list[i].order_type == 2){
									list[i].statusTitle = '已预约'
								}else{
									list[i].statusTitle = '待支付'
								}
							}
							that.orderList.push(list[i])
						}
						
					}else{
						that.finished = true
					}
					that.pages.page++
					that.loading = false
				}else{
					that.finished = true
				}
			})
		},
		// 切换订单类型
		changeOrderType(){
			var that = this
			that.pages.page = 1
			that.orderList = []
			that.getData()
		},
		// 切换订单状态
		changeTab() {
            var that = this
			that.pages.page = 1
			that.orderList = []
			that.getData()
        },
		// 详情
		toDetail(order){
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smartpark/order/detail?order_sn='+order.order_sn
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				that.goNext = true
				that.$router.push({
					path: '/smartpark/order/detail',
					query: {
						order_sn: order.order_sn
					}
				})
			}
		},
		// 支付
		toPay(order){
			var that = this
			var obj = {
				venue_id: order.ticket.venue_id,
				smarkpark_id: order.smarkpark_id,
				is_through_ticket: order.ticket.is_through_ticket,
				id: order.ticket_id
			}
			localStorage.setItem('userTicket',JSON.stringify(obj))
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smartpark/pay?pay_order_num='+order.pay_order_num+'&price'+order.total_price+'&order_id'+order.id
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
				that.goNext = true
                that.$router.push({
					path: '/smartpark/pay',
					query: {
						pay_order_num: order.pay_order_num,
						price: order.total_price,
						order_id: order.id
					}
				})
            }
			
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
